import { render, staticRenderFns } from "./CampaignsGraphs.vue?vue&type=template&id=19a8e7a6&scoped=true"
import script from "./CampaignsGraphs.vue?vue&type=script&lang=ts"
export * from "./CampaignsGraphs.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsGraphs.vue?vue&type=style&index=0&id=19a8e7a6&prod&lang=scss&scoped=true"
import style1 from "./CampaignsGraphs.vue?vue&type=style&index=1&id=19a8e7a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a8e7a6",
  null
  
)

export default component.exports